import { render, staticRenderFns } from "./EditFichaMesa.vue?vue&type=template&id=49eec08c&scoped=true&"
import script from "./EditFichaMesa.vue?vue&type=script&lang=js&"
export * from "./EditFichaMesa.vue?vue&type=script&lang=js&"
import style0 from "./EditFichaMesa.vue?vue&type=style&index=0&id=49eec08c&scoped=true&lang=css&"
import style1 from "./EditFichaMesa.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49eec08c",
  null
  
)

export default component.exports